<template>
    <div>
        <div class="header-btn">
            <el-button size="small" type="warning" @click="openCreate" icon="el-icon-plus"></el-button>
        </div>

        <el-table
                fit
                stripe
                class="data-table"
                @row-click="openEdit"
                :data="data">
            <el-table-column
                    v-for="item in [
                        {prop:'type',label:'Type',fmt:typeFmt},
                        {prop:'eventDate',label:'Date'},
                        {prop:'note',label:'Event'}]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>

        <el-dialog
                v-if="dialogVisible"
                center
                :close-on-click-modal="false"
                :visible.sync="dialogVisible"
                width="40%">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
                <el-form-item prop="type" label="Type">
                    <el-select v-model="form.type" placeholder="Select a type">
                        <el-option
                                v-for="item in types"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="note" label="Event">
                    <el-input v-model="form.note" placeholder="Enter event details" type="textarea" :autosize="{ minRows: 2 }"></el-input>
                </el-form-item>

                <el-form-item prop="eventDate" label="Event Date">
                    <el-date-picker v-model="form.eventDate" type="date" format="dd MMM yyyy"
                                    value-format="yyyy-MM-dd"
                                    placeholder="Pick a date"></el-date-picker>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveData">Save</el-button>
                <el-button type="danger" size="medium" @click="deleteData(form.id)" v-if="!isCreate" >Delete</el-button>
                <el-button @click="dialogVisible = false">Cancel</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {createEvent, deleteEvent, events, updateEvent} from '@/api/BulletinAPI'

export default {
  name: "BulletinCalendar",
  data: function () {
    return {
      dialogVisible: false,
      isCreate: false,
      form: {},
      loading: false,
      data: [],
      page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
      types: [{value: 1, label: 'Maintenance'}, {value: 2, label: 'Meeting'}, {value: 3, label: 'Event'}],
                typesMap: {},
                rules: {
                    type: [
                        {required: true, message: 'Please select one type', trigger: 'blur'},
                    ],
                    note: [
                        {required: true, message: 'Please input the event description', trigger: 'blur'},
                    ], eventDate: [
                        {required: true, message: 'Please select the date ', trigger: 'blur'},
                    ],
                }
            }
        },
        methods: {
            deleteData(id) {
                this.$deleteRequest(this,deleteEvent,id)
            },
            loadData() {
                this.$pageUtils(this, events)
            },
            openCreate() {
                this.form = {icon: {}}
                this.dialogVisible = true
                this.isCreate = true
            },
            typeFmt(row, cel, val) {
                return this.typesMap[val]
            },
            openEdit(row) {
                this.form = this.$copy(row);
                this.dialogVisible = true
                this.isCreate = false
            },
            saveData() {
                const action = this.form.id ? updateEvent : createEvent;
                this.$refs['form'].validate((valid) => {
                    const form = this.$copy(this.form)
                    delete form.icon
                    if (valid) {
                        action(form)
                            .then(() => {
                                this.loadData()
                                this.dialogVisible = false
                            })
                    }
                })
            }
        },
        mounted() {
            this.types.forEach(item => {
                this.typesMap[item.value] = item.label
            })
            this.loadData()
        }
    }
</script>

<style scoped>

</style>
